// Global debounce delay in milliseconds
export const DEBOUNCE_DELAY = 500;
